module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/send-btn/send-btn.scss
// module id = ./web/modern/components/buttons/send-btn/send-btn.scss
// module chunks = 0